import React, { PureComponent } from 'react';
import SplitPane from 'react-split-pane';
import QuerySidebar from './QuerySidebar';
import RequestPanel from './RequestPanel';
import ResponsePanel from './ResponsePanel';

class QueryTab extends PureComponent {
    render() {
        const canSave = !!this.props.user && this.props.queryValid;
        const canSend = !!this.props.environment.app.user && this.props.queryValid;

        return (
            <div className="query-tab">
                <QuerySidebar
                    user={this.props.user}
                    onLogin={this.props.onLogin}
                    savedQueries={this.props.savedQueries}
                    queryFilter={this.props.queryFilter}
                    onClickQuery={this.props.onSelectQuery}
                    onDeleteQuery={this.props.onDeleteQuery}
                    onChangeFilter={this.props.onChangeQueryFilter} />
                <SplitPane split="vertical" minSize={50} defaultSize="50%" className="content">
                    <RequestPanel
                        query={this.props.query}
                        environmentKey={this.props.environmentKey}
                        environment={this.props.environment}
                        onEditQuery={this.props.onChangeQuery}
                        onExecuteRequest={this.props.onExecuteRequest}
                        onLogin={this.props.onEnvironmentLogin}
                        onSaveQuery={this.props.onSaveQuery}
                        saveEnabled={canSave}
                        sendEnabled={canSend} />
                    <ResponsePanel
                        response={this.props.response} />
                </SplitPane>
            </div>
        );
    }
}

export default QueryTab;



// WEBPACK FOOTER //
// ./src/components/QueryTab.js